import React, {useEffect, useState} from 'react';
import {useHistory, useParams} from "react-router-dom";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import {httpClient} from "../../core/HttpClient";
import LocationView from "../Location/LocationView";
import Avatar from "@mui/material/Avatar";
import {TextI18n} from "../TextI18n";
import CardHeader from "@mui/material/CardHeader";
import Fab from "@mui/material/Fab";
import AssistantDirectionIcon from "@mui/icons-material/AssistantDirection";
import Control from "react-leaflet-custom-control";
import {useTranslation} from "react-i18next";
import IconButton from "@mui/material/IconButton";

export default function LocationPage(props) {
    const { t } = useTranslation();
    const { cid } = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [shop, setShop] = useState({lat:0, lng:0});
    console.log('LocationPage');

    useEffect(() => {
        console.log('[LocationPage]', cid);
        try {

            const url = process.env.REACT_APP_API_BASE_URL + '/publish/account';
            httpClient.get(url)
                .then(res => {
                    if(res.data){
                        setShop(res.data);
                        setLoading(false);
                    }
                }).catch(e=>{
                console.log('error', e);
                setLoading(false);
            });


        } catch (e){
            console.log(e);
        }
    }, [history, props, cid]);

    const handleGoToLocation = ()=>{
        window.open(`https://www.google.com/maps/dir/?api=1&destination=${shop.lat},${shop.lng}&dir_action=navigate`, '_blank');
    };

    return (
        <div>
            {loading &&
                <Box display="flex" justifyContent="center" mt={4}>
                    <CircularProgress size={20}/>
                </Box>
            }
            {!loading &&
                <>
                    <Box p={1}>
                        <CardHeader
                            sx={{
                                'paddingTop': '6px',
                                'paddingBottom': '6px',
                                'paddingLeft': '8px',
                                'paddingRight': '8px',
                                '& .MuiCardHeader-action': {
                                    margin: 'auto',
                                },
                            }}
                            avatar={
                                <Avatar aria-label="recipe"
                                        variant={"square"}
                                        src={(shop.image && shop.image.name)?`${process.env.REACT_APP_CDN_BASE_URL}/${shop.image.permission}/merchant/s/${shop.image.name}`:`${process.env.REACT_APP_CDN_BASE_URL}/public/assets/empty_store.png`} />
                            }
                            title={
                                <Box>
                                    <TextI18n value={shop.name}></TextI18n>
                                </Box>
                            }
                            titleTypographyProps={{variant: "h6"}}
                            action={
                                <Box>
                                    <IconButton aria-label="google map"
                                                onClick={handleGoToLocation}>
                                        <AssistantDirectionIcon color="action" />
                                    </IconButton>
                                </Box>
                            }
                        />
                    </Box>
                    <Box style={{height: '800px'}}>
                        <LocationView lat={shop.lat} lng={shop.lng} zoom={15} />
                    </Box>
                    <Box>
                        <Control position='bottomleft'>
                            <Box>
                                <Fab variant="extended" sx={{width: '100%'}} onClick={handleGoToLocation}>
                                    <AssistantDirectionIcon sx={{ mr: 1 }} />
                                    {t('shop.gotoLocation')}
                                </Fab>
                            </Box>
                        </Control>
                    </Box>
                </>
            }
        </div>
    );
}
